import { Link } from "react-router-dom";
import { categories } from "@/mocks/categories";

export default function Footer() {
  return (
    <footer className="bg-primary-900 text-background-100">
      <div className="container-site grid gap-10 py-12 md:grid-cols-2 md:py-16 lg:grid-cols-4">
        <div>
          <div className="flex items-center gap-2.5">
            <span className="flex h-9 w-9 items-center justify-center rounded-full bg-accent-500 text-primary-950">
              <i className="ri-sparkling-2-fill text-lg" />
            </span>
            <span className="font-heading text-lg font-bold text-background-50">
              妖精<span className="text-accent-300">漫画堂</span>
            </span>
          </div>
          <p className="mt-4 text-sm leading-relaxed text-background-200/90">
            专注韩国妖精漫画的奇幻魔法、异世界穿越、精灵契约与妖怪神话题材，为每一位幻想爱好者提供清爽的选漫与追更体验。
          </p>
          <div className="mt-5 flex items-center gap-3">
            <a href="#" aria-label="Twitter" rel="nofollow" className="flex h-9 w-9 items-center justify-center rounded-full bg-background-50/10 text-background-100 transition-colors hover:bg-accent-500 hover:text-primary-950">
              <i className="ri-twitter-x-line" />
            </a>
            <a href="#" aria-label="微博" rel="nofollow" className="flex h-9 w-9 items-center justify-center rounded-full bg-background-50/10 text-background-100 transition-colors hover:bg-accent-500 hover:text-primary-950">
              <i className="ri-weibo-line" />
            </a>
            <a href="#" aria-label="哔哩哔哩" rel="nofollow" className="flex h-9 w-9 items-center justify-center rounded-full bg-background-50/10 text-background-100 transition-colors hover:bg-accent-500 hover:text-primary-950">
              <i className="ri-bilibili-line" />
            </a>
          </div>
        </div>

        <div>
          <h3 className="font-heading text-base font-semibold text-background-50">题材分类</h3>
          <ul className="mt-4 space-y-2.5">
            {categories.map((c) => (
              <li key={c.slug}>
                <Link to={`/category/${c.slug}`} className="text-sm text-background-200/90 transition-colors hover:text-accent-300">
                  {c.name}
                </Link>
              </li>
            ))}
            <li>
              <Link to="/about" className="text-sm text-background-200/90 transition-colors hover:text-accent-300">
                全部作品精选
              </Link>
            </li>
          </ul>
        </div>

        <div>
          <h3 className="font-heading text-base font-semibold text-background-50">快速导航</h3>
          <ul className="mt-4 space-y-2.5">
            <li><Link to="/" className="text-sm text-background-200/90 transition-colors hover:text-accent-300">首页</Link></li>
            <li><Link to="/about" className="text-sm text-background-200/90 transition-colors hover:text-accent-300">关于我们</Link></li>
            <li><Link to="/faq" className="text-sm text-background-200/90 transition-colors hover:text-accent-300">常见问题</Link></li>
            <li><Link to="/contact" className="text-sm text-background-200/90 transition-colors hover:text-accent-300">联系我们</Link></li>
          </ul>
        </div>

        <div>
          <h3 className="font-heading text-base font-semibold text-background-50">联系我们</h3>
          <ul className="mt-4 space-y-2.5 text-sm text-background-200/90">
            <li className="flex items-center gap-2">
              <i className="ri-mail-line text-accent-300" />
              <span>fairy@example.com</span>
            </li>
            <li className="flex items-center gap-2">
              <i className="ri-time-line text-accent-300" />
              <span>工作日 9:00 - 18:00</span>
            </li>
            <li className="flex items-center gap-2">
              <i className="ri-message-3-line text-accent-300" />
              <span>投稿与建议欢迎随时留言</span>
            </li>
          </ul>
        </div>
      </div>

      <div className="border-t border-background-50/10">
        <div className="container-site flex flex-col items-center justify-between gap-2 py-5 text-xs text-background-200/70 sm:flex-row">
          <p>© {new Date().getFullYear()} 妖精漫画堂 · 韩国妖精漫画奇幻魔法异世界在线看</p>
          <p className="flex items-center gap-1.5">
            <i className="ri-heart-3-line text-accent-300" />
            尊重原创，支持正版
          </p>
        </div>
      </div>
    </footer>
  );
}